import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "option", "empty"]

  toggle() {
    if (!this.hasSearchTarget) return

    if (this.element.open) {
      this.searchTarget.focus()
    } else {
      this.searchTarget.value = ""
      this.filter()
    }
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    const matches = this.optionTargets.filter((option) => {
      const matched = option.dataset.name.includes(query)
      option.classList.toggle("hidden", !matched)
      return matched
    })

    this.emptyTarget.classList.toggle("hidden", matches.length > 0)
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) return

    this.close()
  }

  close() {
    this.element.open = false
  }
}
